import { PureComponent } from 'react'
import styled from 'glamorous'
import { withRouter } from 'react-router-dom'
import { $ } from 'utils'

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: 70,
  padding: '10px 20px',
  border: '3px solid transparent',
  borderBottom: '1px solid var(--borderColor)',
  transition: 'border-color ease-in 0.3s',
  boxSizing: 'border-box',
  backgroundColor: 'white',
  '&:hover': {
    border: '3px solid var(--violet)',
    paddingBottom: '8px',
    cursor: 'pointer'
  }
})

const ListName = styled.div({
  fontWeight: 'bold'
})

const ListId = styled.div({
  color: 'var(--grey)'
})

export class TokenListItem extends PureComponent {

  handleSelect = () => {
    const { history, location, token } = this.props
    history.push({
      pathname: `/tokens/${token.uuid}`,
      search: location.search,
    })
  }

  render = () => {
    const { token } = this.props
    return (
      $(Container, { onClick: this.handleSelect },
        $(ListName, token.tokenData),
        $(ListId, token.uuid),
      )
    )
  }
}

export default withRouter(TokenListItem)



// WEBPACK FOOTER //
// ./src/pages/Tokens/TokenListItem.js